var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomersTable',{attrs:{"query":{ gateway: _vm.gatewayId },"excludeColumns":['ID Sage', 'Code Visibble']},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var customer = ref.customer;
return [_c('sui-button',{staticClass:"tiny",on:{"click":function($event){return _vm.goToConfiguration(customer)}}},[_vm._v(_vm._s(_vm.$t('common.config')))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }